import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  target: 'ent:!subawards:!subaward',
  quantity: 1,
  selection: {
    '@': 'award',
  },
  subqueries: {
    project: {
      ref: {
        attr: 'attr:ent#!subawards#!subaward:!proj',
      },
      target: 'ent:!projects:!proj',
    },
    award: {
      ref: {
        attr: 'attr:ent#!projects#!proj:!award',
      },
      target: 'ent:!awards:!award',
      using: 'project',
      selection: {
        '{}': {
          name: 'Award',
          type: 'details',
          content: {
            '{}': {
              fields: {
                '[]': [
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          id: 'code',
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!awards#!award:!code',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          id: 'name',
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!awards#!award:!name',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          id: 'fan',
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!awards#!award:!fan',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!fan',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          id: 'fain',
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!awards#!award:!fain',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!fain',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          id: 'award_date',
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!awards#!award:!award_date',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!award_date',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          id: 'budget',
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!awards#!award:!budget',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!budget',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Sponsor',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'sponsorName',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
            },
          },
        },
      },
      subqueries: {
        sponsorName: {
          ref: {
            attr: 'attr:ent#!awards#!award:!sponsor',
          },
          target: 'ent:!sponsors:!sponsor',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
  },
}
